export default "__VITE_ASSET__b286b3ab__"